'use client';

import { Toaster } from 'sonner';

export function AppToaster() {
  return (
    <Toaster
      position="top-right"
      offset={80}
      duration={3500}
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast: 'font-sans text-sm shadow-2xl',
        },
      }}
    />
  );
}
